import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
export { Radio, RadioGroup } from '@chakra-ui/react';
export type { RadioGroupProps, RadioProps } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(radioAnatomy.keys);

const baseStyle = definePartsStyle({
  control: {
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'palette_gray.40',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    _checked: {
      borderColor: 'palette_blue.100',
      borderWidth: '2px',
      backgroundColor: 'palette_blue.5',
      _disabled: {
        backgroundColor: 'palette_gray.5',
        borderColor: 'palette_gray.40',
        _after: {
          backgroundColor: 'palette_gray.100'
        }
      },
      _after: {
        content: '""',
        position: 'absolute',
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: 'palette_blue.100'
      },
      _hover: {
        borderColor: 'palette_blue.100',
        borderWidth: '2px',
        backgroundColor: 'palette_blue.5'
      }
    }
  }
});

export const radioTheme = defineMultiStyleConfig({ baseStyle });
